import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/founder/')({
  component: FounderIndex,
});

const TILES: Array<{ to: '/founder/decisions' | '/founder/identity-output' | '/founder/calendar' | '/founder/time-audit' | '/founder/proof' | '/founder/checkin'; label: string; description: string }> = [
  { to: '/founder/decisions', label: 'decision log', description: 'capture decisions as you make them. review weekly.' },
  { to: '/founder/identity-output', label: 'identity vs output', description: "the project is behind. you are not the project." },
  { to: '/founder/proof', label: 'proof ledger', description: 'evidence from your own record. when the imposter voice gets loud, this is what the coach points at.' },
  { to: '/founder/checkin', label: 'weekly check-in', description: 'energy + one win + one release. a minute, every sunday.' },
  { to: '/founder/calendar', label: 'calendar shape', description: 'we read the shape of your week. never the content.' },
  { to: '/founder/time-audit', label: 'time-truth audit', description: 'tell us how the month went. we compare quietly.' },
];

function FounderIndex() {
  return (
    <section className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="text-2xl font-semibold tracking-tight">founder mode</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        tools for the shape of pain that's specific to your role. all hidden in human mode.
      </p>

      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        {TILES.map((t) => (
          <Link
            key={t.to}
            to={t.to}
            className="rounded-[var(--radius)] border border-border p-4 hover:bg-muted"
          >
            <div className="font-medium">{t.label}</div>
            <div className="mt-1 text-sm text-muted-foreground">{t.description}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
